'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Created by sidchik on 22.03.17.
 */

var DEFAULT_PATH = exports.DEFAULT_PATH = '/main';
var NOT_FOUND_PATH = exports.NOT_FOUND_PATH = '^NOT_FOUND_404$';

var TOKEN_DATA_STORAGE_KEY = exports.TOKEN_DATA_STORAGE_KEY = 'TOKEN_DATA_STORAGE_KEY';
//# sourceMappingURL=constants.js.map


//////////////////
// WEBPACK FOOTER
// ./~/perx-uikit/dist/constants.js
// module id = 309
// module chunks = 5